(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["beyondfeed-brochure-flipbook"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initFlipbook = (root) => {
      if (root.dataset.brochureReady === 'true') {
        return;
      }

      root.dataset.brochureReady = 'true';
      const pageImages = Array.from(root.querySelectorAll('[data-brochure-page]'));
      const previousButton = root.querySelector('[data-brochure-prev]');
      const nextButton = root.querySelector('[data-brochure-next]');
      const count = root.querySelector('[data-brochure-count]');
      const totalPages = Number(root.dataset.pageCount) || pageImages.length;
      let page = 1;
      let spreadMode = window.matchMedia('(min-width: 750px)').matches;

      const updateControls = () => {
        const step = spreadMode ? 2 : 1;
        previousButton.disabled = page <= 1;
        nextButton.disabled = page + step - 1 >= totalPages;

        if (spreadMode) {
          const lastVisiblePage = Math.min(page + 1, totalPages);
          count.textContent = `${page}-${lastVisiblePage} / ${totalPages}`;
        } else {
          count.textContent = `${page} / ${totalPages}`;
        }
      };

      const draw = () => {
        spreadMode = window.matchMedia('(min-width: 750px)').matches;
        pageImages.forEach((image) => {
          const pageNumber = Number(image.dataset.brochurePage);
          const isVisible = pageNumber === page || (spreadMode && pageNumber === page + 1);
          image.hidden = !isVisible;
          image.classList.toggle('is-left', isVisible && pageNumber === page);
          image.classList.toggle('is-right', isVisible && pageNumber === page + 1);
        });
        updateControls();
      };

      const goToPage = (nextPage, direction) => {
        page = Math.min(Math.max(nextPage, 1), totalPages);
        root.classList.add(`is-turning-${direction}`);
        draw();
        window.setTimeout(() => {
          root.classList.remove(`is-turning-${direction}`);
        }, 380);
      };

      draw();

      previousButton.addEventListener('click', () => {
        const step = spreadMode ? 2 : 1;
        goToPage(page - step, 'prev');
      });

      nextButton.addEventListener('click', () => {
        const step = spreadMode ? 2 : 1;
        goToPage(page + step, 'next');
      });

      let resizeTimer;
      window.addEventListener('resize', () => {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(draw, 160);
      });
    };

    const initAllFlipbooks = () => {
      document.querySelectorAll('[data-brochure-flipbook]').forEach(initFlipbook);
    };

    document.addEventListener('DOMContentLoaded', initAllFlipbooks);
    document.addEventListener('shopify:section:load', initAllFlipbooks);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
